module.exports = __webpack_public_path__ + "static/media/caat.06abe786.png";